import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { prettyDate } from '@scramble/utils';
import s from './index.module.scss';

export const UpdatedDate = ({ date, className }) => {
  const { t, i18n } = useTranslation('loan-terms')

  if (!date) return null;

  return (
    <div className={classnames(s.updated, className, 'f-small-accent')}>
      {t('root_page.updated', { date: prettyDate(date, 'MMMM YYYY', i18n.language) })}
    </div>
  );
};